<template>
    <div class="connector-card" :style="{ position: 'relative' }">
        <v-btn
            class="connect-btn"
            @click="connectChannel"
            v-if="checkRole(projectId, 'project:connector:edit')"
            :disabled="!checkRole(projectId, 'project:connector:edit')"
            x-small
            outlined
        >
            {{ buttonText }}
            <v-icon v-if="isAdditional" x-small class="ml-1">mdi-currency-rub</v-icon>
        </v-btn>
        <div class="connector-card-content">
            <v-avatar :color="channelAvatar.color" size="42" class="mx-2 my-2 inactive-avatar">
                <v-img 
                    v-if="channelAvatar.image" 
                    style="position: absolute;"
                    transition="slide-x-transition" 
                    :src="channelAvatar.image"
                    class="inactive-image"
                />
                <span v-else>{{ channelAvatar.symbol }}</span>
            </v-avatar>
            <div class="connector-card-name-wrapper">
                <h3 :title="displayName">{{ displayName }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkRole } from '@root/src/helpers/roles'
import { PROVIDER_TYPES, PROVIDER_TO_CHANNEL_MAP, CONNECTOR_TYPES } from '@root/src/vars/general'

export default {
    name: 'InactiveChannelCard',
    props: {
        channelType: {
            type: String,
            required: true,
        },
        isAdditional: {
            type: Boolean,
            default: false,
        },
        futureIndex: {
            type: Number,
            default: 1,
        },
        projectId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['connectorAvatarByType']),
        channelAvatar() {
            const channelType = PROVIDER_TO_CHANNEL_MAP[this.channelType]
            return this.connectorAvatarByType(channelType) || {
                color: 'white',
                symbol: '?',
                name: 'Неизвестно',
            }
        },
        displayName() {
            const baseNames = {
                [PROVIDER_TYPES.whatsappBasis]: 'WhatsApp',
                [PROVIDER_TYPES.whatsappApi]: 'WhatsApp',
                [PROVIDER_TYPES.whatsapp]: 'WhatsApp',
                [PROVIDER_TYPES.whatsappDh]: 'WhatsApp',
                [PROVIDER_TYPES.telegramApi]: 'Telegram',
                [PROVIDER_TYPES.telegramDh]: 'Telegram',
                [PROVIDER_TYPES.maxBasis]: 'MAX',
                [PROVIDER_TYPES.maxDh]: 'MAX',
                [PROVIDER_TYPES.maxBusiness]: 'MAX Business',
                [PROVIDER_TYPES.smsGate]: 'SMS',
            }
            const baseName = baseNames[this.channelType] || this.channelType
            
            if (this.futureIndex === 1) {
                return baseName
            } else {
                return `${baseName} ${this.futureIndex}`
            }
        },
        buttonText() {
            return this.isAdditional ? 'Подключить' : 'Подключить'
        },
    },
    methods: {
        checkRole,
        connectChannel() {
            if (this.channelType === PROVIDER_TYPES.whatsapp) {
                const path = this.$router.currentRoute.path.split('/').slice(0, 3).join('/')
                this.$router.push(`${path}/addConnectorStage1?type=${CONNECTOR_TYPES.whatsapp}`)
                return
            }
            
            const channelGroups = {
                [PROVIDER_TYPES.whatsappBasis]: 'whatsapp',
                [PROVIDER_TYPES.whatsappApi]: 'whatsapp',
                [PROVIDER_TYPES.whatsappDh]: 'whatsapp',
                [PROVIDER_TYPES.telegramApi]: 'telegram',
                [PROVIDER_TYPES.telegramDh]: 'telegram',
                [PROVIDER_TYPES.maxBasis]: 'max',
                [PROVIDER_TYPES.maxDh]: 'max',
                [PROVIDER_TYPES.maxBusiness]: 'maxBusiness',
                [PROVIDER_TYPES.smsGate]: 'sms',
            }
            
            const groupId = channelGroups[this.channelType]
            
            this.$store.commit('setChannelCreationMode', true)
            this.$store.commit('setChannelCreationStage', 1)
            this.$store.commit('setIsConnectorSettingsSidebar', true)
            // Устанавливаем query параметр для фильтрации списка каналов (без изменения роута)
            if (this.$route.query.group !== groupId) {
                const newUrl = new URL(window.location.href)
                newUrl.searchParams.set('group', groupId)
                window.history.replaceState({}, '', newUrl.toString())
            }
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
.connector-card
    width: 328px
    border: 1px solid #0000001F
    border-radius: 4px
    background-color: #F5F5F5
.connector-card-name-wrapper
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden
    flex: 1
    min-width: 0
    h3
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
        margin: 0
::v-deep .connect-btn
    position: absolute
    top: 8px
    right: 8px
    z-index: 1
    min-width: auto !important
    padding: 0px 4px !important
    height: 16px !important
    white-space: nowrap !important
    font-size: 8px !important
    background: transparent !important
    border: 1px solid #4CAF50 !important
    color: #4CAF50 !important
    &.v-size--x-small
        min-width: auto !important
        padding: 0px 4px !important
        height: 16px !important
    .v-btn__content
        font-size: 8px !important
        padding: 0 !important
        height: auto !important
        min-width: auto !important
        color: #4CAF50 !important
    .v-icon
        font-size: 10px !important
        width: 10px !important
        height: 10px !important
        margin-left: 2px !important
        color: #4CAF50 !important
.connector-card-content
    padding-left: 16px
    padding-right: 16px
    padding-top: 7px
    padding-bottom: 7px
    display: flex
    flex-direction: row
    align-items: center
button:focus
    outline: 0
.inactive-image
    filter: saturate(0%)
::v-deep .inactive-avatar
    background-color: #9E9E9E !important
</style>
